<script>
var STATUS_META = {
  pending: { cls: "badge bg-warning-subtle text-warning", icon: "ri-time-line", text: "รอตรวจสอบ" },
  approved: { cls: "badge bg-success-subtle text-success", icon: "ri-checkbox-circle-line", text: "ผ่านการพิจารณา" },
  rejected: { cls: "badge bg-danger-subtle text-danger", icon: "ri-close-circle-line", text: "ไม่ผ่านการพิจารณา" },
  duplicate: { cls: "badge bg-info-subtle text-info", icon: "ri-file-copy-2-line", text: "ใบสมัครซ้ำ" },
  incomplete: { cls: "badge bg-secondary-subtle text-secondary", icon: "ri-file-warning-line", text: "ข้อมูลไม่ครบ" },
};

export default {
  name: "ApplicationList",
  props: {
    config: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data: function () {
    var cfg = this.config || {};
    return {
      loading: true,
      error: "",
      pageTitle: String(cfg.pageTitle || "ใบสมัครรอตรวจสอบ"),
      status: String(cfg.defaultStatus || "pending"),
      registryOpened: String(cfg.defaultRegistryOpened || ""),
      dateFrom: "",
      dateTo: "",
      search: "",
      page: 1,
      perPage: 10,
      totalPages: 1,
      from: 0,
      to: 0,
      total: 0,
      rows: [],
      stats: { pending: 0, approved: 0, rejected: 0, incomplete: 0, duplicate_name: 0 },
      selectedIds: {},
      deleting: false,
      debounceTimer: null,
      sort: "created_desc",
    };
  },
  computed: {
    canDelete: function () {
      return !!(this.config && this.config.canDelete);
    },
    colSpan: function () {
      return this.canDelete ? 10 : 9;
    },
    selectedCount: function () {
      var total = 0;
      var key;
      for (key in this.selectedIds) {
        if (Object.prototype.hasOwnProperty.call(this.selectedIds, key) && this.selectedIds[key] === true) {
          total++;
        }
      }
      return total;
    },
    selectableIdsOnPage: function () {
      var ids = [];
      var i;
      var id;
      for (i = 0; i < this.rows.length; i++) {
        id = parseInt(this.rows[i] && this.rows[i].id, 10);
        if (!isNaN(id) && id > 0) {
          ids.push(String(id));
        }
      }
      return ids;
    },
    allPageSelected: function () {
      var ids = this.selectableIdsOnPage;
      var i;
      if (!ids.length) {
        return false;
      }
      for (i = 0; i < ids.length; i++) {
        if (this.selectedIds[ids[i]] !== true) {
          return false;
        }
      }
      return true;
    },
    somePageSelected: function () {
      var ids = this.selectableIdsOnPage;
      var i;
      var selected = 0;
      if (!ids.length) {
        return false;
      }
      for (i = 0; i < ids.length; i++) {
        if (this.selectedIds[ids[i]] === true) {
          selected++;
        }
      }
      return selected > 0 && selected < ids.length;
    },
    pageInfoText: function () {
      if (this.loading || this.error) {
        return "-";
      }
      return "แสดง " + this.from + "-" + this.to + " จาก " + this.total + " รายการ";
    },
    pageNumbers: function () {
      var start = Math.max(1, this.page - 2);
      var end = Math.min(this.totalPages, start + 4);
      if (end - start < 4) {
        start = Math.max(1, end - 4);
      }
      var nums = [];
      var p;
      for (p = start; p <= end; p++) {
        nums.push(p);
      }
      return nums;
    },
    dateRangeInvalid: function () {
      return this.dateFrom !== "" && this.dateTo !== "" && this.dateFrom > this.dateTo;
    },
  },
  mounted: function () {
    this.loadApplications();
  },
  beforeUnmount: function () {
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }
  },
  methods: {
    statusMeta: function (status) {
      var s = String(status || "").toLowerCase();
      if (["submitted", "pending", "pending_review"].indexOf(s) !== -1) {
        return STATUS_META.pending;
      }
      if (["approved", "accepted", "pass", "passed"].indexOf(s) !== -1) {
        return STATUS_META.approved;
      }
      if (["rejected", "declined", "failed", "not_approved"].indexOf(s) !== -1) {
        return STATUS_META.rejected;
      }
      if (s === "duplicate") {
        return STATUS_META.duplicate;
      }
      if (["incomplete", "missing_data"].indexOf(s) !== -1) {
        return STATUS_META.incomplete;
      }
      return { cls: "badge bg-light text-muted", icon: "", text: "ไม่ระบุ" };
    },
    roleBadges: function (row) {
      var parts = [];
      if (row && row.is_composer) {
        parts.push({ cls: "badge bg-primary-subtle text-primary", text: "ทำนอง" });
      }
      if (row && row.is_author) {
        parts.push({ cls: "badge bg-success-subtle text-success", text: "เนื้อร้อง" });
      }
      if (row && row.is_arranger) {
        parts.push({ cls: "badge bg-info-subtle text-info", text: "เรียบเรียง" });
      }
      return parts;
    },
    toThaiDateTime: function (raw) {
      var t = String(raw || "").trim();
      if (t === "") {
        return "-";
      }
      var d = new Date(t.replace(" ", "T"));
      if (isNaN(d.getTime())) {
        return t;
      }
      return d.toLocaleString("th-TH", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
      });
    },
    shortNote: function (note) {
      var text = String(note || "").trim();
      if (text.length > 48) {
        return text.slice(0, 48) + "…";
      }
      return text;
    },
    truncate: function (text) {
      return String(text || "").trim();
    },
    detailHref: function (row) {
      var base = String((this.config && this.config.basePath) || "");
      var prefix = base === "" ? "" : base;
      return (
        prefix +
        "/main-manage-application-member.php?page=view_application_member" +
        "&id=" +
        encodeURIComponent(row.id || "") +
        "&application_no=" +
        encodeURIComponent(row.application_no || "") +
        "&name=" +
        encodeURIComponent(row.applicant_name || "")
      );
    },
    isSelected: function (row) {
      var id = parseInt(row && row.id, 10);
      if (isNaN(id) || id <= 0) {
        return false;
      }
      return this.selectedIds[String(id)] === true;
    },
    canSelect: function (row) {
      var id = parseInt(row && row.id, 10);
      return !isNaN(id) && id > 0;
    },
    toggleRow: function (row, checked) {
      var id = parseInt(row && row.id, 10);
      var copy;
      if (isNaN(id) || id <= 0) {
        return;
      }
      copy = Object.assign({}, this.selectedIds);
      if (checked) {
        copy[String(id)] = true;
      } else {
        delete copy[String(id)];
      }
      this.selectedIds = copy;
    },
    toggleSelectAll: function (event) {
      var checked = event.target.checked === true;
      var copy = Object.assign({}, this.selectedIds);
      var ids = this.selectableIdsOnPage;
      var i;
      for (i = 0; i < ids.length; i++) {
        if (checked) {
          copy[ids[i]] = true;
        } else {
          delete copy[ids[i]];
        }
      }
      this.selectedIds = copy;
    },
    buildFilterParams: function (includePaging) {
      var params = new URLSearchParams();
      if (includePaging) {
        params.set("page", String(this.page));
        params.set("per_page", String(this.perPage));
      }
      params.set("status", this.status || "all");
      if (String(this.registryOpened || "").trim() !== "") {
        params.set("registry_opened", String(this.registryOpened).trim());
      }
      if (String(this.dateFrom || "").trim() !== "") {
        params.set("date_from", String(this.dateFrom).trim());
      }
      if (String(this.dateTo || "").trim() !== "") {
        params.set("date_to", String(this.dateTo).trim());
      }
      params.set("search", String(this.search || "").trim());
      params.set("sort", String(this.sort || "created_desc").trim());
      return params;
    },
    isSortActive: function (key) {
      return this.sort === key + "_asc" || this.sort === key + "_desc";
    },
    isSortAsc: function (key) {
      return this.sort === key + "_asc";
    },
    isSortDesc: function (key) {
      return this.sort === key + "_desc";
    },
    ariaSort: function (key) {
      if (this.sort === key + "_asc") {
        return "ascending";
      }
      if (this.sort === key + "_desc") {
        return "descending";
      }
      return "none";
    },
    cycleSort: function (key) {
      var current = this.sort;
      var defaultDesc = key === "created" || key === "registry";
      var next;
      if (defaultDesc) {
        next = current === key + "_desc" ? key + "_asc" : key + "_desc";
      } else {
        next = current === key + "_asc" ? key + "_desc" : key + "_asc";
      }
      this.sort = next;
      this.page = 1;
      this.loadApplications();
    },
    onSortKey: function (event, key) {
      if (event.key === "Enter" || event.key === " ") {
        event.preventDefault();
        this.cycleSort(key);
      }
    },
    loadApplications: function () {
      var self = this;
      var apiUrl = String((this.config && this.config.apiUrl) || "").trim();
      this.perPage = this.perPage === 25 || this.perPage === 50 ? this.perPage : 10;
      this.error = "";
      if (this.dateRangeInvalid) {
        this.loading = false;
        this.rows = [];
        this.error = "วันที่เริ่มต้นต้องไม่มากกว่าวันที่สิ้นสุด";
        return;
      }
      if (apiUrl === "") {
        this.loading = false;
        this.error = "ไม่พบที่อยู่ API ของรายการใบสมัคร";
        return;
      }
      this.loading = true;
      fetch(apiUrl + "?" + this.buildFilterParams(true).toString(), {
        credentials: "same-origin",
        headers: { Accept: "application/json" },
      })
        .then(function (res) {
          return res.json();
        })
        .then(function (json) {
          if (!json || json.success !== true) {
            throw new Error(json && json.message ? json.message : "โหลดข้อมูลไม่สำเร็จ");
          }
          self.rows = Array.isArray(json.rows) ? json.rows : [];
          self.page = Number(json.page || 1);
          self.totalPages = Math.max(1, Number(json.total_pages || 1));
          self.from = Number(json.from || 0);
          self.to = Number(json.to || 0);
          self.total = Number(json.total || 0);
          self.stats = Object.assign(
            { pending: 0, approved: 0, rejected: 0, incomplete: 0, duplicate_name: 0 },
            json.stats || {}
          );
          self.loading = false;
        })
        .catch(function (err) {
          self.loading = false;
          self.rows = [];
          self.error = err && err.message ? err.message : "โหลดข้อมูลไม่สำเร็จ";
        });
    },
    queueReload: function () {
      var self = this;
      this.page = 1;
      if (this.debounceTimer) {
        clearTimeout(this.debounceTimer);
      }
      this.debounceTimer = setTimeout(function () {
        self.loadApplications();
      }, 350);
    },
    onPerPageChange: function () {
      var v = Number(this.perPage);
      this.perPage = v === 25 || v === 50 ? v : 10;
      this.page = 1;
      this.loadApplications();
    },
    activateStatus: function (nextStatus) {
      if (!nextStatus) {
        return;
      }
      this.status = this.status === nextStatus ? "all" : nextStatus;
      this.queueReload();
    },
    onStatKey: function (event, nextStatus) {
      if (event.key === "Enter" || event.key === " ") {
        event.preventDefault();
        this.activateStatus(nextStatus);
      }
    },
    exportCsv: function () {
      var apiUrl = String((this.config && this.config.apiUrl) || "").trim();
      if (this.dateRangeInvalid) {
        window.alert("วันที่เริ่มต้นต้องไม่มากกว่าวันที่สิ้นสุด");
        return;
      }
      if (apiUrl === "") {
        return;
      }
      var params = this.buildFilterParams(false);
      params.set("export", "csv");
      window.location.href = apiUrl + "?" + params.toString();
    },
    deleteApplicationById: function (appId) {
      var deleteApi = String((this.config && this.config.deleteApiUrl) || "").trim();
      var payload = new URLSearchParams();
      payload.set("application_id", String(appId));
      return fetch(deleteApi, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
        },
        credentials: "same-origin",
        body: payload.toString(),
      })
        .then(function (res) {
          return res.json();
        })
        .then(function (json) {
          if (!json || json.success !== true) {
            throw new Error(json && json.message ? json.message : "ลบข้อมูลไม่สำเร็จ");
          }
          return true;
        });
    },
    goPrev: function () {
      if (this.page > 1) {
        this.page -= 1;
        this.loadApplications();
      }
    },
    goNext: function () {
      if (this.page < this.totalPages) {
        this.page += 1;
        this.loadApplications();
      }
    },
    goPage: function (n) {
      this.page = Number(n || 1);
      this.loadApplications();
    },
    deleteSelected: function () {
      var self = this;
      var ids = [];
      var key;
      var parsedId;
      var queue;
      var success = 0;
      var failed = 0;
      if (!this.canDelete || this.deleting) {
        return;
      }
      for (key in this.selectedIds) {
        if (Object.prototype.hasOwnProperty.call(this.selectedIds, key) && this.selectedIds[key] === true) {
          parsedId = parseInt(key, 10);
          if (!isNaN(parsedId) && parsedId > 0) {
            ids.push(parsedId);
          }
        }
      }
      if (!ids.length) {
        window.alert("กรุณาเลือกใบสมัครที่ต้องการลบ");
        return;
      }
      if (!window.confirm("ยืนยันการลบใบสมัครที่เลือกทั้งหมด " + ids.length + " รายการ?")) {
        return;
      }
      this.deleting = true;
      queue = Promise.resolve();
      ids.forEach(function (id) {
        queue = queue.then(function () {
          return self
            .deleteApplicationById(id)
            .then(function () {
              success++;
              var copy = Object.assign({}, self.selectedIds);
              delete copy[String(id)];
              self.selectedIds = copy;
            })
            .catch(function () {
              failed++;
            });
        });
      });
      queue.finally(function () {
        self.deleting = false;
        self.loadApplications();
        if (failed > 0) {
          window.alert("ลบสำเร็จ " + success + " รายการ และล้มเหลว " + failed + " รายการ");
          return;
        }
        window.alert("ลบข้อมูลสำเร็จ " + success + " รายการ");
      });
    },
  },
};
</script>

<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div class="page-title-box d-sm-flex align-items-center justify-content-between bg-galaxy-transparent">
          <h4 class="mb-sm-0"><i class="ri-file-list-3-line me-1 align-middle"></i>{{ pageTitle }}</h4>
          <div class="page-title-right">
            <ol class="breadcrumb m-0">
              <li class="breadcrumb-item"><a href="javascript:void(0);">ใบสมัครออนไลน์</a></li>
              <li class="breadcrumb-item active">{{ pageTitle }}</li>
            </ol>
          </div>
        </div>
      </div>
    </div>

    <div class="row g-3 mb-3 row-cols-2 row-cols-xl-5">
      <div class="col">
        <div
          class="card card-animate h-100 shadow-sm bg-warning-subtle border border-warning border-opacity-50 rounded-3 application-stat-card"
          :class="{ 'is-active': status === 'pending' }"
          role="button"
          tabindex="0"
          :aria-pressed="status === 'pending' ? 'true' : 'false'"
          title="คลิกเพื่อกรองรอตรวจสอบ"
          @click="activateStatus('pending')"
          @keydown="onStatKey($event, 'pending')"
        >
          <div class="card-body">
            <div class="d-flex align-items-center">
              <div class="flex-grow-1">
                <p class="text-uppercase fw-semibold text-warning-emphasis mb-1 small">รอตรวจสอบ</p>
                <h3 class="mb-0 fw-bold text-warning">{{ stats.pending || 0 }}</h3>
              </div>
              <div class="avatar-sm flex-shrink-0">
                <span class="avatar-title bg-warning-subtle text-warning rounded-circle fs-4"><i class="ri-time-line"></i></span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col">
        <div
          class="card card-animate h-100 shadow-sm bg-success-subtle border border-success border-opacity-50 rounded-3 application-stat-card"
          :class="{ 'is-active': status === 'approved' }"
          role="button"
          tabindex="0"
          :aria-pressed="status === 'approved' ? 'true' : 'false'"
          title="คลิกเพื่อกรองผ่านการพิจารณา"
          @click="activateStatus('approved')"
          @keydown="onStatKey($event, 'approved')"
        >
          <div class="card-body">
            <div class="d-flex align-items-center">
              <div class="flex-grow-1">
                <p class="text-uppercase fw-semibold text-success-emphasis mb-1 small">ผ่านการพิจารณา</p>
                <h3 class="mb-0 fw-bold text-success">{{ stats.approved || 0 }}</h3>
              </div>
              <div class="avatar-sm flex-shrink-0">
                <span class="avatar-title bg-success-subtle text-success rounded-circle fs-4"><i class="ri-checkbox-circle-line"></i></span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col">
        <div
          class="card card-animate h-100 shadow-sm bg-danger-subtle border border-danger border-opacity-50 rounded-3 application-stat-card"
          :class="{ 'is-active': status === 'rejected' }"
          role="button"
          tabindex="0"
          :aria-pressed="status === 'rejected' ? 'true' : 'false'"
          title="คลิกเพื่อกรองไม่ผ่านการพิจารณา"
          @click="activateStatus('rejected')"
          @keydown="onStatKey($event, 'rejected')"
        >
          <div class="card-body">
            <div class="d-flex align-items-center">
              <div class="flex-grow-1">
                <p class="text-uppercase fw-semibold text-danger-emphasis mb-1 small">ไม่ผ่านการพิจารณา</p>
                <h3 class="mb-0 fw-bold text-danger">{{ stats.rejected || 0 }}</h3>
              </div>
              <div class="avatar-sm flex-shrink-0">
                <span class="avatar-title bg-danger-subtle text-danger rounded-circle fs-4"><i class="ri-close-circle-line"></i></span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col">
        <div
          class="card card-animate h-100 shadow-sm bg-secondary-subtle border border-secondary border-opacity-50 rounded-3 application-stat-card"
          :class="{ 'is-active': status === 'incomplete' }"
          role="button"
          tabindex="0"
          :aria-pressed="status === 'incomplete' ? 'true' : 'false'"
          title="คลิกเพื่อกรองข้อมูลไม่ครบ"
          @click="activateStatus('incomplete')"
          @keydown="onStatKey($event, 'incomplete')"
        >
          <div class="card-body">
            <div class="d-flex align-items-center">
              <div class="flex-grow-1">
                <p class="text-uppercase fw-semibold text-secondary-emphasis mb-1 small">ข้อมูลไม่ครบ</p>
                <h3 class="mb-0 fw-bold text-secondary">{{ stats.incomplete || 0 }}</h3>
              </div>
              <div class="avatar-sm flex-shrink-0">
                <span class="avatar-title bg-secondary-subtle text-secondary rounded-circle fs-4"><i class="ri-file-warning-line"></i></span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col">
        <div
          class="card card-animate h-100 shadow-sm bg-info-subtle border border-info border-opacity-50 rounded-3 application-stat-card"
          :class="{ 'is-active': status === 'duplicate_name' }"
          role="button"
          tabindex="0"
          :aria-pressed="status === 'duplicate_name' ? 'true' : 'false'"
          title="คลิกเพื่อกรองชื่อซ้ำทั้งระบบ"
          @click="activateStatus('duplicate_name')"
          @keydown="onStatKey($event, 'duplicate_name')"
        >
          <div class="card-body">
            <div class="d-flex align-items-center">
              <div class="flex-grow-1">
                <p class="text-uppercase fw-semibold text-info-emphasis mb-1 small">ชื่อซ้ำ</p>
                <h3 class="mb-0 fw-bold text-info">{{ stats.duplicate_name || 0 }}</h3>
              </div>
              <div class="avatar-sm flex-shrink-0">
                <span class="avatar-title bg-info-subtle text-info rounded-circle fs-4"><i class="ri-user-shared-line"></i></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="card-body">
        <div class="row g-3">
          <div class="col-xl-3 col-md-6">
            <label class="form-label" for="application-status-filter">สถานะใบสมัคร</label>
            <select id="application-status-filter" v-model="status" class="form-select" @change="queueReload">
              <option value="all">ทั้งหมด</option>
              <option value="pending">รอตรวจสอบ</option>
              <option value="approved">ผ่านการพิจารณา</option>
              <option value="rejected">ไม่ผ่านการพิจารณา</option>
              <option value="duplicate">ใบสมัครซ้ำ</option>
              <option value="incomplete">ข้อมูลไม่ครบ</option>
              <option value="duplicate_name">ชื่อซ้ำ (ทั้งระบบ)</option>
            </select>
          </div>
          <div class="col-xl-3 col-md-6">
            <label class="form-label" for="application-registry-opened-filter">การเปิดดู (ทีมทะเบียน)</label>
            <select id="application-registry-opened-filter" v-model="registryOpened" class="form-select" @change="queueReload">
              <option value="">ทั้งหมด</option>
              <option value="not_opened">ยังไม่เปิดดู</option>
              <option value="opened">เปิดดูแล้ว</option>
            </select>
          </div>
          <div class="col-xl-3 col-md-6">
            <label class="form-label" for="application-date-from-filter">วันที่สมัคร (เริ่ม)</label>
            <input id="application-date-from-filter" v-model="dateFrom" type="date" class="form-control" @change="queueReload">
          </div>
          <div class="col-xl-3 col-md-6">
            <label class="form-label" for="application-date-to-filter">วันที่สมัคร (ถึง)</label>
            <input id="application-date-to-filter" v-model="dateTo" type="date" class="form-control" @change="queueReload">
          </div>
          <div class="col-12">
            <label class="form-label" for="application-search-filter">ค้นหา</label>
            <div class="input-group">
              <span class="input-group-text"><i class="ri-search-line"></i></span>
              <input
                id="application-search-filter"
                v-model="search"
                type="text"
                class="form-control"
                placeholder="ชื่อผู้สมัคร, เลขที่ใบสมัคร, เลขบัตรประชาชน, อีเมล, เบอร์โทร, นามปากกา, ชื่อเพลง"
                @input="queueReload"
              >
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="card-header d-flex flex-wrap justify-content-between align-items-center gap-2">
        <h4 class="card-title mb-0">Table - {{ pageTitle }}</h4>
        <div class="d-flex align-items-center gap-2">
          <button
            v-if="canDelete"
            type="button"
            class="btn btn-soft-danger btn-sm"
            :disabled="selectedCount <= 0 || deleting"
            @click="deleteSelected"
          >
            <i class="ri-delete-bin-line align-bottom me-1"></i>{{ deleting ? "กำลังลบ..." : "ลบที่เลือก (" + selectedCount + ")" }}
          </button>
          <button type="button" class="btn btn-soft-success btn-sm" @click="exportCsv">
            <i class="ri-file-excel-2-line align-bottom me-1"></i>ส่งออก Excel (CSV)
          </button>
          <button type="button" class="btn btn-soft-secondary btn-sm" @click="loadApplications">
            <i class="ri-refresh-line align-bottom me-1"></i>รีเฟรชข้อมูล
          </button>
        </div>
      </div>
      <div class="card-body">
        <div class="table-responsive table-card">
          <table class="table align-middle table-nowrap table-striped table-hover table-bordered mb-0">
            <thead class="table-light">
              <tr>
                <th v-if="canDelete" style="width: 44px;" class="text-center">
                  <input
                    type="checkbox"
                    aria-label="เลือกทั้งหมด"
                    :checked="allPageSelected"
                    :indeterminate.prop="somePageSelected"
                    :disabled="selectableIdsOnPage.length === 0"
                    @change="toggleSelectAll"
                  >
                </th>
                <th style="width: 60px;">#</th>
                <th
                  class="application-sort"
                  :class="{ 'text-primary': isSortActive('application_no') }"
                  :aria-sort="ariaSort('application_no')"
                  title="คลิกเพื่อเรียงตามเลขที่ใบสมัคร"
                  role="button"
                  tabindex="0"
                  @click="cycleSort('application_no')"
                  @keydown="onSortKey($event, 'application_no')"
                >
                  เลขที่ใบสมัคร
                  <span class="application-sort-arrows" aria-hidden="true">
                    <i class="mdi mdi-menu-up" :class="{ 'is-on': isSortAsc('application_no') }"></i>
                    <i class="mdi mdi-menu-down" :class="{ 'is-on': isSortDesc('application_no') }"></i>
                  </span>
                </th>
                <th
                  class="application-sort"
                  :class="{ 'text-primary': isSortActive('name') }"
                  :aria-sort="ariaSort('name')"
                  title="คลิกเพื่อเรียงตามชื่อผู้สมัคร"
                  role="button"
                  tabindex="0"
                  @click="cycleSort('name')"
                  @keydown="onSortKey($event, 'name')"
                >
                  ชื่อผู้สมัคร
                  <span class="application-sort-arrows" aria-hidden="true">
                    <i class="mdi mdi-menu-up" :class="{ 'is-on': isSortAsc('name') }"></i>
                    <i class="mdi mdi-menu-down" :class="{ 'is-on': isSortDesc('name') }"></i>
                  </span>
                </th>
                <th
                  class="application-sort"
                  :class="{ 'text-primary': isSortActive('email') }"
                  :aria-sort="ariaSort('email')"
                  title="คลิกเพื่อเรียงตามอีเมล / เบอร์โทร"
                  role="button"
                  tabindex="0"
                  @click="cycleSort('email')"
                  @keydown="onSortKey($event, 'email')"
                >
                  อีเมล / เบอร์โทร
                  <span class="application-sort-arrows" aria-hidden="true">
                    <i class="mdi mdi-menu-up" :class="{ 'is-on': isSortAsc('email') }"></i>
                    <i class="mdi mdi-menu-down" :class="{ 'is-on': isSortDesc('email') }"></i>
                  </span>
                </th>
                <th
                  class="application-sort"
                  :class="{ 'text-primary': isSortActive('song_title') }"
                  :aria-sort="ariaSort('song_title')"
                  title="คลิกเพื่อเรียงตามชื่อเพลง"
                  role="button"
                  tabindex="0"
                  @click="cycleSort('song_title')"
                  @keydown="onSortKey($event, 'song_title')"
                >
                  ชื่อเพลง
                  <span class="application-sort-arrows" aria-hidden="true">
                    <i class="mdi mdi-menu-up" :class="{ 'is-on': isSortAsc('song_title') }"></i>
                    <i class="mdi mdi-menu-down" :class="{ 'is-on': isSortDesc('song_title') }"></i>
                  </span>
                </th>
                <th
                  class="application-sort"
                  :class="{ 'text-primary': isSortActive('created') }"
                  :aria-sort="ariaSort('created')"
                  title="คลิกเพื่อเรียงตามวันที่สมัคร"
                  role="button"
                  tabindex="0"
                  @click="cycleSort('created')"
                  @keydown="onSortKey($event, 'created')"
                >
                  วันที่สมัคร
                  <span class="application-sort-arrows" aria-hidden="true">
                    <i class="mdi mdi-menu-up" :class="{ 'is-on': isSortAsc('created') }"></i>
                    <i class="mdi mdi-menu-down" :class="{ 'is-on': isSortDesc('created') }"></i>
                  </span>
                </th>
                <th
                  class="application-sort"
                  :class="{ 'text-primary': isSortActive('status') }"
                  :aria-sort="ariaSort('status')"
                  title="คลิกเพื่อเรียงตามสถานะ"
                  role="button"
                  tabindex="0"
                  @click="cycleSort('status')"
                  @keydown="onSortKey($event, 'status')"
                >
                  สถานะ
                  <span class="application-sort-arrows" aria-hidden="true">
                    <i class="mdi mdi-menu-up" :class="{ 'is-on': isSortAsc('status') }"></i>
                    <i class="mdi mdi-menu-down" :class="{ 'is-on': isSortDesc('status') }"></i>
                  </span>
                </th>
                <th
                  class="application-sort"
                  :class="{ 'text-primary': isSortActive('registry') }"
                  :aria-sort="ariaSort('registry')"
                  title="คลิกเพื่อเรียงตามการเปิดดูของทีมทะเบียน"
                  role="button"
                  tabindex="0"
                  style="min-width: 200px;"
                  @click="cycleSort('registry')"
                  @keydown="onSortKey($event, 'registry')"
                >
                  ทีมทะเบียน
                  <span class="application-sort-arrows" aria-hidden="true">
                    <i class="mdi mdi-menu-up" :class="{ 'is-on': isSortAsc('registry') }"></i>
                    <i class="mdi mdi-menu-down" :class="{ 'is-on': isSortDesc('registry') }"></i>
                  </span>
                </th>
                <th style="width: 88px;">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="loading">
                <td :colspan="colSpan" class="text-muted">กำลังโหลดข้อมูล...</td>
              </tr>
              <tr v-else-if="error">
                <td :colspan="colSpan" class="text-danger text-center py-4">{{ error }}</td>
              </tr>
              <tr v-else-if="rows.length === 0">
                <td :colspan="colSpan" class="text-center text-muted py-4">ไม่พบข้อมูลใบสมัคร</td>
              </tr>
              <template v-else>
                <tr v-for="(row, idx) in rows" :key="row.id || idx" :class="{ 'table-warning': row.is_duplicate_name === true }">
                  <td v-if="canDelete" class="text-center">
                    <input
                      type="checkbox"
                      :checked="isSelected(row)"
                      :disabled="!canSelect(row)"
                      aria-label="เลือกใบสมัคร"
                      @change="toggleRow(row, $event.target.checked)"
                    >
                  </td>
                  <td>{{ from + idx }}</td>
                  <td>{{ row.application_no || "-" }}</td>
                  <td>
                    {{ String(row.applicant_name || "").trim() || "-" }}
                    <span v-if="row.is_duplicate_name === true" class="badge bg-warning-subtle text-warning ms-1">
                      <i class="ri-user-shared-line align-middle me-1"></i>ชื่อซ้ำ
                    </span>
                    <div class="mt-1">
                      <div v-if="roleBadges(row).length" class="d-flex flex-wrap gap-1">
                        <span v-for="badge in roleBadges(row)" :key="badge.text" :class="badge.cls">{{ badge.text }}</span>
                      </div>
                      <span v-else class="text-muted">-</span>
                    </div>
                  </td>
                  <td>
                    <div class="small lh-sm">
                      <div class="text-truncate" style="max-width:200px" :title="truncate(row.email) || '-'">
                        <i class="ri-mail-line text-muted me-1 align-middle"></i>
                        <span v-if="truncate(row.email)">{{ truncate(row.email) }}</span>
                        <span v-else class="text-muted">-</span>
                      </div>
                      <div class="mt-1">
                        <i class="ri-phone-line text-muted me-1 align-middle"></i>
                        <span v-if="String(row.phone || '').trim()">{{ String(row.phone || '').trim() }}</span>
                        <span v-else class="text-muted">-</span>
                      </div>
                    </div>
                  </td>
                  <td>
                    <span v-if="truncate(row.song_title)" class="d-inline-block text-truncate align-bottom" style="max-width:160px" :title="truncate(row.song_title)">{{ truncate(row.song_title) }}</span>
                    <span v-else class="text-muted">-</span>
                  </td>
                  <td>{{ toThaiDateTime(row.created_at) }}</td>
                  <td>
                    <span :class="statusMeta(row.status).cls">
                      <i v-if="statusMeta(row.status).icon" :class="statusMeta(row.status).icon" class="align-middle me-1"></i>{{ statusMeta(row.status).text }}
                    </span>
                  </td>
                  <td class="small">
                    <template v-if="Object.prototype.hasOwnProperty.call(row, 'registry_viewed_at') || Object.prototype.hasOwnProperty.call(row, 'registry_review_note')">
                      <div v-if="String(row.registry_viewed_at || '').trim()" class="d-flex align-items-center gap-2 flex-wrap small">
                        <span class="badge bg-success-subtle text-success"><i class="ri-eye-line align-middle me-1"></i>เปิดดูแล้ว</span>
                        <span class="text-muted">{{ toThaiDateTime(row.registry_viewed_at) }}</span>
                        <span v-if="String(row.registry_viewed_by || '').trim()" class="text-muted">โดย {{ String(row.registry_viewed_by || '').trim() }}</span>
                      </div>
                      <span v-else-if="Object.prototype.hasOwnProperty.call(row, 'registry_viewed_at')" class="badge bg-light text-muted">
                        <i class="ri-eye-off-line align-middle me-1"></i>ยังไม่เปิดดู
                      </span>
                      <div v-if="String(row.registry_review_note || '').trim()" class="small text-body mt-1">{{ shortNote(row.registry_review_note) }}</div>
                    </template>
                    <template v-else>-</template>
                  </td>
                  <td>
                    <a :href="detailHref(row)" class="btn btn-sm btn-soft-info btn-icon" title="ดูรายละเอียด" aria-label="ดูรายละเอียด">
                      <i class="ri-eye-line fs-16"></i>
                    </a>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>

        <div class="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-3 mt-3">
          <div class="d-flex align-items-center gap-3">
            <small class="text-muted">{{ pageInfoText }}</small>
            <select v-model.number="perPage" class="form-select form-select-sm" style="width: 4.75rem" aria-label="จำนวนแถวต่อหน้า" @change="onPerPageChange">
              <option :value="10">10</option>
              <option :value="25">25</option>
              <option :value="50">50</option>
            </select>
          </div>
          <div class="pagination-wrap hstack gap-2">
            <button type="button" class="btn btn-sm btn-light" :disabled="page <= 1" @click="goPrev">Previous</button>
            <ul class="pagination listjs-pagination mb-0">
              <li v-for="n in pageNumbers" :key="n" class="page-item" :class="{ active: n === page }">
                <button type="button" class="page-link" @click="goPage(n)">{{ n }}</button>
              </li>
            </ul>
            <button type="button" class="btn btn-sm btn-light" :disabled="page >= totalPages" @click="goNext">Next</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.application-stat-card {
  cursor: pointer;
}
.application-stat-card.is-active {
  outline: 2px solid rgba(33, 37, 41, 0.35);
  outline-offset: 1px;
}
.application-sort {
  cursor: pointer;
  white-space: nowrap;
  user-select: none;
}
.application-sort:hover {
  color: var(--vz-primary);
}
.application-sort-arrows {
  display: inline-flex;
  flex-direction: column;
  justify-content: center;
  margin-left: 0.35rem;
  vertical-align: middle;
  line-height: 0.45;
}
.application-sort-arrows .mdi {
  display: block;
  font-size: 1.05rem;
  height: 0.55rem;
  line-height: 0.45;
  color: var(--vz-secondary-color, #878a99);
  opacity: 0.45;
}
.application-sort:hover .application-sort-arrows .mdi {
  opacity: 0.75;
}
.application-sort-arrows .mdi.is-on {
  color: var(--vz-primary);
  opacity: 1;
}
</style>
